import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios"
const SausageContext = createContext();

export const SausageProvider = ({ children }) => {
  const [infoSausage, setInfoSausage] = useState({
    previsaoVendas: 0,
    estoque: 0,
    previsaoProducao: 0,
    custoUnitario: 0,
    receitaProduto: 0,
    pesoCaixa: 1,
    preco: 15.90
  });
  const [insumosSausage, setInsumosSausage] = useState([])
  const [stockSausageMarket, setStockSausageMarket] = useState(0)

  function getSausageStockMp() {

    const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

    if (!storagedCurrentUserGame?.supermercado) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/7/${storagedCurrentUserGame?.supermercado}`)
      .then(response => {
        setStockSausageMarket(response.data ? response.data.quantidade : 0)
      })

  }

  function getSausageStock() {

    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
    if (!storagedIndustry) return
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/7/${storagedIndustry?.industria}`)
      .then(response => {
        console.log('estoque S', response.data);
        setInfoSausage({
          previsaoVendas: 0,
          estoque: response.data ? response.data.quantidade : 0,
          previsaoProducao: 0,
          custoUnitario: infoSausage.custo,
          receitaProduto: infoSausage.receitaProduto,
          pesoCaixa: 1,
          preco: 15.90
        })
      })

  }

  useEffect(() => {

    const storagedJogo = JSON.parse(localStorage.getItem('@App:jogo'));

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarInsumos/7`)
      .then(response => {
        // console.log(response)
        setInsumosSausage(response.data)

      })

    axios.get("https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarTodos")
      .then(response => {
        const data = response.data[0]
        const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));


        const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

        if (storagedCurrentUserGame?.supermercado) {
          //get do estoque do supermercado
          axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/7/${storagedCurrentUserGame?.supermercado}`)
            .then(response => {
              setStockSausageMarket(response.data ? response.data.quantidade : 0)
              setInfoSausage({
                custoUnitario: data.custo
              })
            })
          return
        }

        if (!storagedIndustry) return
        //get das infos e estoque da industria
        axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/7/${storagedIndustry?.industria}`)
          .then(response => {
            setInfoSausage({
              previsaoVendas: 0,
              estoque: response.data ? response.data.quantidade : 0,
              previsaoProducao: 0,
              custoUnitario: data.custo,
              receitaProduto: infoSausage.receitaProduto,
              pesoCaixa: 1,
              preco: 15.90
            })
          })
      })

    // setInfoSausage(infoSausage);
  }, []);
  return (
    <SausageContext.Provider
      value={{
        infoSausage,
        setInfoSausage,
        insumosSausage,
        setInsumosSausage,
        stockSausageMarket,
        getSausageStockMp,
        getSausageStock
      }}
    >
      {children}
    </SausageContext.Provider>
  );
};

export const useSausage = () => useContext(SausageContext);
